module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "body3.21fe9dc0.svg" + "?" + Date.now();